import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/common/Button/Button';

/**
 * Register Button Component
 * Navigates to login route with signup modal query param
 * Uses Button component with primary gradient style
 */
const RegisterButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/login?modalType=auth-signup');
  };

  return (
    <Button 
      variant="primary"
      size="sm"
      onClick={handleClick}
    >
      Sign up
    </Button>
  );
};

export default RegisterButton;
